import { MedicalChronologyProvider } from "@/components/MedicalChronology/contexts/MedicalChronologyProvider";
import React from "react";
import { useParams } from "react-router-dom";

import "../../styles/MedicalChronology.css";
import { MedicalChronologyShell } from "./MedicalChronologyShell";

export const MedicalChronology: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();
  if (!caseId) {
    return null;
  }

  return (
    <MedicalChronologyProvider key={caseId} caseId={caseId}>
      <MedicalChronologyShell />
    </MedicalChronologyProvider>
  );
};
